const contact = {
  id: 'Group',
};

export default contact;
